import { useState } from "react"

export const useGrooveRecallModalState = () => {
  const [recallModal, setRecallModal] = useState(false)

  const toggleRecallModal = (e) => {
    e?.preventDefault()
    setRecallModal(!recallModal)
  }

  return { recallModal, toggleRecallModal }
}
